import { RouteInfo } from "../types";
import { authGuard, permissionGuard } from "../guards/index";
import { UIPAGE } from "@/constants/ui-page.constants";

const ViewCustomerHandover = () => import(/* webpackChunkName: "chunk-customer-handover" */ "@/views/customer/handover/CustomerHandover.vue");

const HandoverStep = () => import(/* webpackChunkName: "chunk-customer-handover" */ "@/views/customer/handover/components/HandoverStep.vue");

export const CustomerHandoverRoute: RouteInfo = {
	id: UIPAGE.CUSTOMER_360_HANDOVER_RESEGMENTATION,
	path: "/customers/:customerId/handover",
	component: ViewCustomerHandover,
	guards: [authGuard, permissionGuard],
	props: (route) => ({
		customerId: route.query.customerId
	}),
	title: "customers.customer_360.handover.process",
	children: [
		{
			id: UIPAGE.CUSTOMER_360_HANDOVER_RESEGMENTATION,
			path: "resegmentation",
			component: HandoverStep,
			title: "customers.customer_360.handover.resegmentation"
		}
	]
};
